import { InviteOpenAcceptSource } from './invite-open-accept-source.enum';

export enum LoginMethod {
  ManualLogin = 'manual_login',
  ManualMagicLink = 'manual_magic_link',
  SmsOtherLink = 'sms_other_link',
  SmsOtp = 'sms_otp',
  EmailOtherLink = 'email_other_link',
  SmsInviteLink = InviteOpenAcceptSource.SmsInviteLink,
  RcsInviteLink = InviteOpenAcceptSource.Rcs,
  EmailInviteLink = InviteOpenAcceptSource.EmailInviteLink,
  SameSession = InviteOpenAcceptSource.SameSession,
  Other = InviteOpenAcceptSource.Other,
}
